import React from 'react';

type Props = {
  url?: string;
  srcDoc?: string;
  title: string;
  style?: React.CSSProperties;
};

export const HtmlIframeViewer: React.FC<Props> = ({
  url,
  srcDoc,
  title,
  style
}) => {
  return (
    <iframe
      src={url}
      srcDoc={srcDoc}
      title={title}
      style={{
        width: '100%',
        border: 'none',
        ...style
      }}
      sandbox=""
    />
  );
};
